import {Injectable} from '@angular/core';
import {Contact} from './contact.model';
import {CrudService} from '@ngx-ivengi/crud';

@Injectable()
export class ContactService extends CrudService<Contact> {
  public entityType = Contact;
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/contact/contact.service.ts